import React, { useEffect, useState } from "react";
import { FallingLines } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { socket } from "../../App";
import EP1 from "../../assets/images/EP1.jpg";
import EP2 from "../../assets/images/EP2.jpg";
import Logo from "../../assets/icons/Fameo-X-App-icon.png";
import SettingIcon from "../../assets/svg/SettingIcon.svg";
import SearchIcon from "../../assets/svg/search.svg";
import Header from "../../components/Header/Header";
import ScrollToTop from "../../components/Hooks/ScrollToTop";
import axios from "../../components/Hooks/axios";
import ActiveChat from "./ActiveChat";
import Avatar from "../../components/Avatar/Avatar";
import styles from "./Chat.module.scss";
import ChatMessageRequest from "./ChatMessageRequest";
import ChatSetting from "./ChatSetting";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FormatTimeInHHMM } from "../../components/utilis/FormatTime";
import { setPostReload } from "../../redux/slices/tempSlice";
import NotificationImg from "../../assets/images/Bell.png";
import { IoIosArrowRoundBack } from "react-icons/io";

export const Chat = () => {
  const { userId, user } = useSelector((state) => state.auth);
  const [conversations, setConversations] = useState([]);
  const [Search, setSearch] = useState("");
  const [ActiveChatId, setActiveChatID] = useState(null);
  const [SettingPopup, setSettingPopup] = useState(false);
  const [MessageRequest, setMessageRequest] = useState(false);
  const [reload, setReload] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();
  const [activeUserData, setActiveUserData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { notificationsCount } = useSelector((state) => state.notification);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  console.log(isMobile);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (userId === "") return;
    setIsLoading(true);
    axios
      .get(`/conversations/${userId}`)
      .then(({ data }) => {
        setIsLoading(false);
        setConversations(data);
        // if (pathname.split("/")[2] === undefined) setActiveChatID(data[0]);
        // else setActiveChatID(data[pathname.split("/")[2]]);
      })
      .catch(({ response }) => {
        console.log(response);
      });
  }, [userId, reload]);

  useEffect(() => {
    if (!userId || !socket) return;

    if (user && user.is_active === true) {
      socket.emit("joinLoginRoom", { userId });
    } else {
      socket.emit("joinLoginRoom", { userId, activeStatus: false });
    }

    const handleUserOnline = (payload) => {
      setActiveUserData(payload);
    };

    socket.on("userOnline", handleUserOnline);

    // Cleanup: Remove the listener when the component unmounts or userId changes
    return () => {
      socket.off("userOnline", handleUserOnline);
    };
  }, [socket, userId, user]);

  const filterData = conversations.filter((item) => {
    if (
      item?.userData?.username?.toLowerCase()?.includes(Search?.toLowerCase())
    )
      return true;
  });

  const [isChatOpen, setIsChatOpen] = useState(false);

  const onClose = () => {
    if (isChatOpen) {
      setIsChatOpen(false);
      setActiveChatID(null);
    } else {
      navigate("/Home");
    }
  };

  const onCloseSetting = () => {
    if (isChatOpen) {
      setIsChatOpen(false);
    }
    setSettingPopup(false);
  };

  return (
    <div className="App">
      <div className="MainContainer">
        <ScrollToTop />
        {!isMobile && <Header />}
        {isMobile && !isChatOpen && (
          <div className={styles.Top}>
            <div className={styles.Row1}>
              <button className={styles.BackIcon} onClick={onClose}>
                <FaArrowLeftLong />
              </button>
              <h1 className={styles.ChatText}>
                {!isChatOpen
                  ? "Chat"
                  : SettingPopup
                    ? "Chat Setting"
                    : MessageRequest
                      ? "Message Request"
                      : "Chat"}
                {/* Chat */}
              </h1>
            </div>
            <div className={styles.NavButton}>
              <div className={styles.ListItem}>
                {/* <Link>
									{notificationsCount > 0 && <div className={styles.redDot}>{notificationsCount}</div>}
									<img src={NotificationImg} alt="NotificationImg" />
								</Link> */}
              </div>
              <div className={styles.ListItem}>
                <Link to="/Home" onClick={() => dispatch(setPostReload(true))}>
                  <div className={styles.ProfilePic}>
                    <Avatar src={user?.ProfilePic} name={user?.username} />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        )}

        {/* <div className={`${styles.Container} ${styles.Chat}`}> */}
        {!isMobile && (
          <div className={`${styles.Container} ${styles.Chat}`}>
            <div className={styles.LeftChatContainer}>
              <div className={styles.Top}>
                <div className={styles.Row1}>
                  <button className={styles.BackIcon} onClick={onClose}>
                    <IoIosArrowRoundBack
                      style={{ fontSize: "6rem", padding: "0" }}
                    />
                  </button>
                  <h1 className={styles.ChatText}>Chat</h1>
                </div>
              </div>

              <div className={styles.SearchSettingContainer}>
                <div className={styles.SearchContainer}>
                  <input
                    type="search"
                    placeholder="Search"
                    value={Search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <img src={SearchIcon} alt="" />
                </div>
                <div className={styles.SettingIcon}>
                  <img
                    src={SettingIcon}
                    alt=""
                    onClick={() => {
                      setSettingPopup(!SettingPopup);
                      setMessageRequest(false);
                    }}
                  />
                </div>
              </div>

              <div className={styles.OnlineContainer}>
                <h2>Online</h2>
                {/* {console.log(activeUserData)} */}

                {activeUserData.filter((u) => u.userId !== userId).length ===
                  0 ? (
                  <p className={styles.NoOnlineUser}>No user Online</p>
                ) : (
                  <div className={styles.OnlineBoxContainer}>
                    {activeUserData
                      ?.filter((u) => u.userId !== userId)
                      .map((data, index) => (
                        <div key={index} className={styles.OnlineBox}>
                          <Avatar
                            src={data?.userData?.pic}
                            name={data?.userData?.username}
                          />
                          <div className={styles.greenDot} />
                        </div>
                      ))}
                  </div>
                )}
              </div>

              <div className={styles.ChatProfileContainer}>
                {isLoading ? (
                  <div className={styles.loadingContainer}>
                    <FallingLines
                      color="#3A0DBB"
                      width="100"
                      visible={true}
                      ariaLabel="falling-lines-loading"
                    />
                  </div>
                ) : filterData.length === 0 ? (
                  <h2>No Conversation Yet</h2>
                ) : (
                  filterData.map((data, index) => {
                    // console.log(data);
                    if (data.userData !== null)
                      return (
                        <div
                          key={index}
                          className={styles.ChatProfileBox}
                          onClick={() => {
                            setSettingPopup(false);
                            setMessageRequest(false);
                            setActiveChatID(data);
                          }}
                        >
                          <div className={styles.ChatProfileBoxLeft}>
                            <div className={styles.ChatProfileImage}>
                              <Avatar
                                src={data?.userData?.ProfilePic}
                                name={data?.userData?.username}
                              />

                              {activeUserData.map((onlineUser, index) => {
                                if (onlineUser.userId === data?.userData?._id)
                                  return (
                                    <div
                                      key={index}
                                      className={styles.greenDot}
                                    />
                                  );
                              })}
                            </div>
                            <div className={styles.ChatProfileText}>
                              <h2>{data?.userData?.username}</h2>
                              <h5>{data?.resentMessage?.text}</h5>
                            </div>
                          </div>
                          <div className={styles.ChatProfileMeta}>
                            {data?.resentMessage && (
                              <p>
                                {FormatTimeInHHMM(
                                  data?.resentMessage?.updatedAt,
                                )}
                              </p>
                            )}
                            {data?.recentSMS_Count ? (
                              <span>{data?.recentSMS_Count}</span>
                            ) : null}
                          </div>
                        </div>
                      );
                  })
                )}
              </div>
            </div>
            <div className={styles.RightChatContainer}>
              {!ActiveChatId && !SettingPopup && !MessageRequest ? (
                <div className={styles.OverlayWrapper}>
                  <div className={styles.Overlay}>
                    <img src={Logo} alt="" />
                    <h1>Start chat...</h1>
                  </div>
                </div>
              ) : (
                ""
              )}
              {SettingPopup ? (
                <ChatSetting
                  setMessageRequest={setMessageRequest}
                  onClose={() => {
                    setSettingPopup(false);
                  }}
                />
              ) : MessageRequest ? (
                <ChatMessageRequest
                  reload={reload}
                  setReload={setReload}
                  onClose={onCloseSetting}
                />
              ) : (
                ActiveChatId && (
                  <ActiveChat
                    ActiveChatId={ActiveChatId}
                    onBack={() => {
                      setActiveChatID(null);
                      setIsChatOpen(false);
                    }}
                  />
                )
              )}
            </div>
          </div>
        )}

        {isMobile && (
          <div className={`${styles.Container} ${styles.Chat}`}>
            {!isChatOpen ? (
              <div className={styles.LeftChatContainer}>
                <div className={styles.SearchSettingContainer}>
                  <div className={styles.SearchContainer}>
                    <input
                      type="search"
                      placeholder="Search"
                      value={Search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <img src={SearchIcon} alt="" />
                  </div>
                  <div className={styles.SettingIcon}>
                    <img
                      src={SettingIcon}
                      alt=""
                      onClick={() => {
                        setIsChatOpen(true);
                        setSettingPopup(!SettingPopup);
                        setMessageRequest(false);
                      }}
                    />
                  </div>
                </div>

                <div className={styles.OnlineContainer}>
                  <h2>Online</h2>
                  {/* {console.log(activeUserData)} */}

                  {activeUserData.filter((u) => u.userId !== userId).length ===
                    0 ? (
                    <p className={styles.NoOnlineUser}>No user Online</p>
                  ) : (
                    <div className={styles.OnlineBoxContainer}>
                      {activeUserData
                        ?.filter((u) => u.userId !== userId)
                        .map((data, index) => (
                          <div key={index} className={styles.OnlineBox}>
                            <Avatar
                              src={data?.userData?.pic}
                              name={data?.userData?.username}
                            />
                            <div className={styles.greenDot} />
                          </div>
                        ))}
                    </div>
                  )}
                </div>

                <div className={styles.ChatProfileContainer}>
                  {isLoading ? (
                    <div className={styles.loadingContainer}>
                      <FallingLines
                        color="#3A0DBB"
                        width="100"
                        visible={true}
                        ariaLabel="falling-lines-loading"
                      />
                    </div>
                  ) : filterData.length === 0 ? (
                    <h2>No Conversation Yet</h2>
                  ) : (
                    filterData.map((data, index) => {
                      console.log(data);
                      if (data.userData !== null)
                        return (
                          <div
                            key={index}
                            className={styles.ChatProfileBox}
                            onClick={() => {
                              setSettingPopup(false);
                              setMessageRequest(false);
                              setActiveChatID(data);
                              setIsChatOpen(true);
                            }}
                          >
                            <div className={styles.ChatProfileBoxLeft}>
                              <div className={styles.ChatProfileImage}>
                                <Avatar
                                  src={data?.userData?.ProfilePic}
                                  name={data?.userData?.username}
                                />

                                {activeUserData.map((onlineUser, index) => {
                                  if (onlineUser.userId === data?.userData?._id)
                                    return (
                                      <div
                                        key={index}
                                        className={styles.greenDot}
                                      />
                                    );
                                })}
                              </div>
                              <div className={styles.ChatProfileText}>
                                <h2>{data?.userData?.username}</h2>
                                <h5>{data?.resentMessage?.text}</h5>
                              </div>
                            </div>
                            <div className={styles.ChatProfileMeta}>
                              {data?.resentMessage && (
                                <p>
                                  {FormatTimeInHHMM(
                                    data?.resentMessage?.updatedAt,
                                  )}
                                </p>
                              )}
                              {data?.recentSMS_Count ? (
                                <span>{data?.recentSMS_Count}</span>
                              ) : null}
                            </div>
                          </div>
                        );
                    })
                  )}
                </div>
              </div>
            ) : (
              <div className={styles.RightChatContainer}>
                {!ActiveChatId && !SettingPopup && !MessageRequest ? (
                  <div className={styles.OverlayWrapper}>
                    <div className={styles.Overlay}>
                      <img src={Logo} alt="" />
                      <h1>Start chat...</h1>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {SettingPopup ? (
                  <ChatSetting
                    setMessageRequest={setMessageRequest}
                    setSettingPopup={setSettingPopup}
                    onCloseSetting={onCloseSetting}
                  />
                ) : MessageRequest ? (
                  <ChatMessageRequest
                    reload={reload}
                    setReload={setReload}
                    onClose={onCloseSetting}
                  />
                ) : (
                  ActiveChatId && (
                    <ActiveChat
                      ActiveChatId={ActiveChatId}
                      onBack={() => {
                        setActiveChatID(null);
                        setIsChatOpen(false);
                      }}
                    />
                  )
                )}
              </div>
            )}
          </div>
        )}
      </div>
      {/* </div> */}
    </div>
  );
};
